module.exports = __webpack_public_path__ + "static/img/logo_6.87d4605.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/logo_6.png
// module id = t7Fo
// module chunks = 1